import { navLinks } from '@/mocks/home';

interface SiteFooterProps {
  onJump: (id: string) => void;
}

export default function SiteFooter({ onJump }: SiteFooterProps) {
  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-bold">蜜桃成熟时3D</span>
            </div>
            <p className="mt-4 max-w-md text-background-50/70 text-sm leading-relaxed">
              一个站在怀旧视角的独立专题页，围绕《蜜桃成熟时》原版与 3D 改编展开对照，梳理女主角、幕后、片段、影评与票房，供老影迷回味与讨论。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['1993 原版', '2011 3D 版', '港产类型片', '怀旧专题'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-background-50/10 text-background-50/80 text-xs font-label"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <p className="font-label text-sm text-background-50/90">本页导航</p>
            <ul className="mt-4 space-y-2">
              {navLinks.slice(0, 4).map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => onJump(link.id)}
                    className="text-background-50/65 hover:text-background-50 text-sm cursor-pointer transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-label text-sm text-background-50/90">继续阅读</p>
            <ul className="mt-4 space-y-2">
              {navLinks.slice(4).map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => onJump(link.id)}
                    className="text-background-50/65 hover:text-background-50 text-sm cursor-pointer transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-background-50/55 text-xs leading-relaxed">
            本站为影迷向的回顾与讨论内容，属个人整理与观点分享，不代表任何片方或官方立场。
          </p>
          <p className="text-background-50/55 text-xs whitespace-nowrap">© 2024 蜜桃成熟时3D 怀旧专题</p>
        </div>
      </div>
    </footer>
  );
}